<template>
  <CompactStatusButton
    class="
      tw-justify-start tw-w-8 tw-pl-2 tw-pr-1
      preparation-status-container
      tw-relative
    "
    :class="containerClass"
    :tooltip="tooltip"
    :disabled="preparationLoading"
    :data-heap="`${trackingPrefix}-review-status-${
      preparation ? 'unmark-as-prepared' : 'mark-as-prepared'
    }`"
    data-testid="reconciliation-preparation-status"
    @click="togglePrepared(!preparation)"
  >
    <template #default>
      <WorkflowIconPrepared v-if="preparation" class="tw-block tw-w-4 tw-h-4" />
      <img
        v-else
        :src="$imagesRequire('workflows/not_prepared.svg')"
        class="tw-block tw-w-4 tw-h-4"
      />
    </template>
    <template #hover>
      <i
        v-if="preparation"
        class="
          fa fa-close
          tw-text-sf-gray-dark
          tw-text-sm
          tw-leading-4
          tw-flex
          tw-items-center
          tw-justify-center
          tw-w-4
          tw-h-4
        "
      />
      <WorkflowIconPrepared
        v-else
        class="tw-block tw-w-4 tw-h-4 tw-relative -tw-top-px"
      />
    </template>
  </CompactStatusButton>
</template>

<script lang="ts" setup>
import type { TemplatePreparation } from '@app/application/workflows/types'
import {
  formatCompactTooltip,
  formatPreparationUser,
} from '@app/application/workflows/utils/format-preparation-and-review'
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import WorkflowIconPrepared from '@images/icon-prepared.svg?component'
import CompactStatusButton from './compact-status-button.vue'

interface Props {
  preparation: TemplatePreparation | null
  preparationLoading?: boolean
  trackingPrefix: string
}

const props = withDefaults(defineProps<Props>(), {
  preparationLoading: false,
})

const emit = defineEmits<{ 'toggle-prepared': [boolean] }>()

const I18n = useI18n()

const containerClass = computed(() =>
  props.preparation
    ? '!tw-bg-slate-50'
    : '!tw-bg-white preparation-status-container--white'
)

const tooltip = computed(() => {
  const titleKey = props.preparation
    ? 'reconciliation_preparation.unmark_as_prepared'
    : 'reconciliation_preparation.mark_as_prepared'

  const detail = props.preparation
    ? `${I18n.t(
        'reconciliation_preparation.marked_as_prepared_by'
      )} ${formatPreparationUser(props.preparation)}`
    : ''

  return formatCompactTooltip(I18n.t(titleKey), detail)
})

function togglePrepared(prepared: boolean) {
  emit('toggle-prepared', prepared)
}
</script>
